/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmp_Matrix_TitleInputs */

const en_cmp_matrix_title = /** @type {(inputs: Cmp_Matrix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where the two actually differ`)
};

const id_cmp_matrix_title = /** @type {(inputs: Cmp_Matrix_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di mana keduanya benar-benar berbeda`)
};

/**
* | output |
* | --- |
* | "Where the two actually differ" |
*
* @param {Cmp_Matrix_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_matrix_title = /** @type {((inputs?: Cmp_Matrix_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Matrix_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_matrix_title(inputs)
	return en_cmp_matrix_title(inputs)
});